import React from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import type { User } from '../lib/api';

interface LayoutProps {
  children: React.ReactNode;
  user: User;
  onLogout: () => void;
}

const AppLayout: React.FC<LayoutProps> = ({ children, user, onLogout }) => {
  return (
    <div className="appShell">
      <Sidebar />
      <div className="workspace">
        <Header user={user} onLogout={onLogout} />
        <main className="pageViewport">{children}</main>
      </div>
    </div>
  );
};

export default AppLayout;
